import axios, { AxiosRequestConfig } from 'axios';
import { createHashHistory } from 'history';
import BlueBird from 'bluebird'
import { BASE_URL, TIMEOUT } from '../config/config';
import { Toast, Modal } from 'antd-mobile';
import utils from '../utils/utils';

const history = createHashHistory();

axios.defaults.baseURL = BASE_URL;
axios.defaults.timeout = TIMEOUT;

axios.defaults.headers = {
    'Content-Type': 'application/json;charset=UTF-8',
}

// 跨域带cookies
// axios.defaults.withCredentials = true;

//请求拦截器
axios.interceptors.request.use(function (config) {
    // 判断是否有token
    const token = sessionStorage.getItem('token');
    if (token) {
        let loginResult = JSON.parse(token);
        config.headers = Object.assign({
            'x-auth-token': loginResult.token,
            'Content-Type': 'application/json',
        }, config.headers);
        // config.headers = {
        //     'x-auth-token': loginResult.token,
        //     'Content-Type': 'application/json'
        // };

    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    Toast.fail('请求超时！', 1);
    return Promise.reject(error);
});

//响应拦截器
axios.interceptors.response.use(async (res) => {
    if (res.status === 200) {
        //若token过期
        if (res.data.code === 900) {
            Toast.fail('身份验证超时！重新登录！', 1);
            if (window.location.href.indexOf('/medicalLive') > 0) {
                history.replace('/medicalLive');
                window.location.reload(); // 登录超时, 需要，不然路由变了后，页面没刷新
            } else {
                await toLogin();
            }
            return Promise.resolve(res);
        }
        else {
            return Promise.resolve(res);
        }
    }
    else {
        return Promise.reject(res);
    }
}, err => {
    if (err.code === "ECONNABORTED" && err.message.indexOf("timeout") !== -1) {
        Toast.fail('请求超时！', 1)
    }
    switch (err.response.status) {
        case 404:
            Toast.fail('网络请求不存在', 1);
            history.push('/*');
            window.location.reload();
            break;
        case 500:
            Modal.alert('', '系统正在更新中,请耐心等待3~5分钟', [
                {
                    text: '确定', onPress: () => {
                        if (window.location.href.indexOf('/medicalLive') > 0) {
                            history.replace('/medicalLive');
                            window.location.reload();
                        } else {
                            toLogin();
                        }
                    }
                }
            ])
            // Toast.fail('服务器错误！500', 1);
            // history.push('/serverError');
            // window.location.reload();
            break;
        case 502:
            Modal.alert('', '系统正在更新中,请耐心等待3~5分钟', [
                {
                    text: '确定', onPress: () => {
                        if (window.location.href.indexOf('/medicalLive') > 0) {
                            history.replace('/medicalLive');
                            window.location.reload();
                        } else {
                            toLogin();
                        }
                    }
                }
            ])
            // Toast.fail('服务器错误！502', 1);
            // history.push('/serverError');
            // window.location.reload();
            break;
        case 503:
            Modal.alert('', '系统正在更新中,请耐心等待3~5分钟', [
                {
                    text: '确定', onPress: () => {
                        if (window.location.href.indexOf('/medicalLive') > 0) {
                            history.replace('/medicalLive');
                            window.location.reload();
                        } else {
                            toLogin();
                        }
                    }
                }
            ])
            // Toast.fail('服务器错误！503', 1);
            // history.push('/serverError');
            // window.location.reload();
            break;
        default:
            Toast.fail(err.message, 1);
            break;
    }
    return Promise.reject(err.response);
});

export function post(url: string, params: any) {
    return new Promise((resolve, reject) => {
        axios.post(url, JSON.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

export function get(url: string, params: any) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}



/***
 * @description create http
 * @param axiosConfig
 * @return BlueBird
 */
export function createAxiosHttp<T>(axiosConfig: AxiosRequestConfig = {}): BlueBird<T> {
    return new BlueBird(((resolve, reject) => {
        axios(axiosConfig).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    }))
}

export async function toLogin() {
    let savedUrlParam = localStorage.getItem('OriginUrlParam');
    let needReload = false;
    if (savedUrlParam) {
        let savedOriginUrlParam: any = {};
        try {
            savedOriginUrlParam = JSON.parse(savedUrlParam)
        } catch (error) {
            savedOriginUrlParam = {};
        }
        // 返回至小程序授权、游客登录页
        let _from = savedOriginUrlParam.from;
        if (_from && (_from === 'login' || _from === 'tenant' || _from === 'authGuestIndex')) {
            if (utils.isMiniProgram()) {
                await toWxMiniProgram(`/pages/authGuestIndex/authGuestIndex?jumpUrlFromH5=${encodeURIComponent(`/pages/login/login`)}&fromUrlFromH5=${encodeURIComponent('/doctor/home?tab=home')}`);
                needReload = false;
            }
        } else if (_from === 'patientAeHome') {
            // ae (alk) 上报小程序登录过期重新授权登录
            if (utils.isMiniProgram()) {
                await toWxMiniProgram(`/pages/aeLogin/aeLogin?needLogin=1`);
                needReload = false;
            }
        } else if (_from === 'csoDoctorRegister') {
            // cso登录过期重新登录
            if (utils.isMiniProgram()) {
                await toWxMiniProgram(`/pages/index/index?needLogin=1`);
                needReload = false;
            }
        } else if (_from === 'csoDoctorFreeLogin') {
            // cso免密登录过期重新登录
            if (utils.isMiniProgram()) {
                await toWxMiniProgram(`/pages/freeLogin/freeLogin?needLogin=1`);
                needReload = false;
            }
        } else if (_from === 'EPRO_PT') {
            // epro_pt(epro患者端)免密登录过期重新登录 
            if (utils.isMiniProgram()) {
                await toWxMiniProgram(`/pages/login/login?needLogin=1`);
                needReload = false;
            }
        } else {
            needReload = true;
        }
    } else {
        needReload = true;
    }
    if (needReload) {
        history.replace('/login');
        window.location.reload();
    }
}

export async function toWxMiniProgram(url: string) {
    return new Promise((resolve, reject) => {
        (window as any).wx.miniProgram.redirectTo({
            url: url,
            success: function (e: any) {
                resolve(true);
            },
            fail: function (e: any) {
                resolve(false);
            }
        })
    })
}
